import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "32_map-marker.svg",
  "use": "32_map-marker.svg-usage",
  "viewBox": "0 0 22 29.42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 29.42\" id=\"32_map-marker.svg\"><g id=\"32_map-marker.svg_c\"><g id=\"32_map-marker.svg_d\"><path d=\"m11,.5C5.2.5.5,5.22.5,11.05c0,2.26.71,4.35,1.91,6.07,1.9,2.71,8.59,11.48,8.59,11.48,0,0,6.73-8.8,8.63-11.54,1.18-1.71,1.87-3.78,1.87-6.01C21.5,5.22,16.8.5,11,.5Zm0,15c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5,4.5,2.01,4.5,4.5-2.01,4.5-4.5,4.5Z\" style=\"fill:#ff9198; stroke:#d42314; stroke-miterlimit:50;\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol